import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/home',
      name: 'HomePage',
      component: require('@/components/HomePage').default,
      alias: '/',
      meta: {
        title: '关于KHS'
      }
    },
    {
      path: '/industry',
      name: 'IndustryPage',
      component: require('@/components/IndustryPage').default,
      meta: {
        title: '您的行业'
      }
    },
    {
      path: '/case/:category',
      name: 'CaseNewPage',
      component: require('@/components/CaseNewPage').default,
      meta: {
        title: '客户案例'
      }
    },
    {
      path: '/project',
      name: 'ProjectPage',
      component: require('@/components/ProjectPage').default,
      meta: {
        title: '交钥匙工程'
      }
    },
    {
      path: '/service',
      name: 'ServicePage',
      component: require('@/components/ServicePage').default,
      meta: {
        title: '售后服务'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js